import type { Group, UserRole } from "@/types";

export function getCurrentUserRole(
  userRoles: UserRole[] | undefined,
  currentUserId: number | undefined,
): UserRole | null {
  if (!userRoles?.length || currentUserId == null) {
    return null;
  }

  return userRoles.find((role) => role.userId === currentUserId) ?? null;
}

export function isCurrentUserGroupAdmin(
  group: Group | null,
  currentUserId: number | undefined,
): boolean {
  return getCurrentUserRole(group?.userRoles, currentUserId)?.isAdmin ?? false;
}
